import { Component, OnInit } from '@angular/core'
import { DomSanitizer, SafeHtml } from '@angular/platform-browser'
import { ActivatedRoute, Params, Router } from '@angular/router'

import { environment } from '../../../../../../environments/environment'
import { PostLayout } from '../../../../../shared/enums/post-layout.enum'
import { ResourceSlug } from '../../../../../shared/enums/wordpress/wp-resource-slug.enum'
import { BreadcrumbLink } from '../../../../../shared/interfaces/breadcrumb-link.interface'
import { Document } from '../../../../../shared/interfaces/resources/document.interface'
import { ExternalLink } from '../../../../../shared/interfaces/resources/external-link.interface'
import { Post } from '../../../../../shared/interfaces/resources/post.interface'
import { BreadcrumbService } from '../../../../../shared/services/breadcrumb.service'
import { DocumentService } from '../../../../../shared/services/document.service'
import { MetaService } from '../../../../../shared/services/meta.service'
import { PostService } from '../../../../../shared/services/post.service'
import { Tool } from '../../../interfaces/tool.interface'
import { ExternalLinkService } from '../../../services/external-link.service'
import { ToolService } from '../../../services/tool.service'
import { sidebarTaxonomies } from '../../sidebar-taxonomies.content'

@Component({
  selector: 'app-tool-detail',
  templateUrl: './tool-detail.component.html',
  styleUrls: ['./tool-detail.component.scss']
})
export class ToolDetailComponent implements OnInit {
  tool: Tool
  content: SafeHtml

  resources: string[]
  externalLinks: ExternalLink[]

  breadcrumbLinks: BreadcrumbLink[] = []
  PostLayout = PostLayout

  sidebarTaxonomies: {
    label: string
    propName: string
    queryParamName?: string
  }[] = sidebarTaxonomies

  showReportToolModal: boolean

  ResourceSlug = ResourceSlug
  storagePath: string = environment.apiCatalogStoragePath

  constructor(
    private activatedRoute: ActivatedRoute,
    private toolService: ToolService,
    private postService: PostService,
    private metaService: MetaService,
    private documentService: DocumentService,
    private externalLinkService: ExternalLinkService,
    private breadcrumbService: BreadcrumbService,
    private sanitizerService: DomSanitizer,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      this.toolService.show(params.slug).then(
        (toolRes: Tool) => {
          this.tool = toolRes

          // Sanitize content to allow math formulas.
          this.content = this.sanitizerService.bypassSecurityTrustHtml(
            this.tool.content
          )

          if (this.tool.relatedPostId) {
            this.postService
              .showById(this.tool.relatedPostId)
              .then((postRes: Post) => {
                this.tool.relatedPost = postRes
              })
          }

          if (this.tool.documentIds?.length) {
            this.documentService
              .listByIds(this.tool.documentIds)
              .then((docRes: Document[]) => {
                this.tool.documents = docRes
              })
          }

          if (this.tool.externalLinkIds?.length) {
            this.externalLinkService
              .list({ ids: this.tool.externalLinkIds })
              .then((externalLinkRes: ExternalLink[]) => {
                this.tool.externalLinks = externalLinkRes
              })
          }

          this.breadcrumbLinks = this.breadcrumbService.getBreadCrumbLinks(
            'toolCatalog',
            [
              { label: 'Tools', path: '/catalogue/tools' },
              {
                label: this.tool.name,
                path: `catalogue/tools/${this.tool.slug}`
              }
            ]
          )

          this.metaService.setTags({
            title: `${this.tool.name}`,
            description: this.tool.excerpt,
            path: `catalogue/tools/${this.tool.slug}`,
            absoluteOgImage: this.tool.image
              ? this.tool.image + '-socialCard.jpg'
              : environment.baseUrl + 'assets/images/catalogue-og-image.png'
          })
        },
        () => {
          this.router.navigate(['/404'])
        }
      )
    })
  }

  goToFilteredList(queryParamName: string, queryParamValue: string) {
    this.router.navigate(['/catalogue/tools'], {
      queryParams: {
        [queryParamName]: queryParamValue
      }
    })
  }
}
